// Traits.js
class Traits {
  constructor() {
    this.onChange = () => {};
    this.traits = {
      charisma: { value: 0, label: 'Charisma', multiplier: 1 },
      infamy: { value: 0, label: 'Infamy', multiplier: 1 },
      resilience: { value: 0, label: 'Resilience', multiplier: 1 },
      haggling: { value: 0, label: 'Haggling', multiplier: 1 },

      luck: { value: 5, label: 'Luck', multiplier: 1 },
      stealth: { value: 0, label: 'Stealth', multiplier: 1 }
      // Additional traits here
      // intimidation: { value: 0, label: 'Intimidation', multiplier: 1 },
      // strength: { value: 0, label: 'Strength', multiplier: 1 },
      // intelligence: { value: 0, label: 'Intelligence', multiplier: 1 },
      // dexterity: { value: 0, label: 'Dexterity', multiplier: 1 },
      // wisdom: { value: 0, label: 'Wisdom', multiplier: 1 },
      // constitution: { value: 0, label: 'Constitution', multiplier: 1 },
      // perception: { value: 0, label: 'Perception', multiplier: 1 },
      // agility: { value: 0, label: 'Agility', multiplier: 1 },
      // endurance: { value: 0, label: 'Endurance', multiplier: 1 },
      // willpower: { value: 0, label: 'Willpower', multiplier: 1 },
      // luck: { value: 0, label: 'Luck', multiplier: 1 },
      // faith: { value: 0, label: 'Faith', multiplier: 1 },
      // sanity: { value: 0, label: 'Sanity', multiplier: 1 },
      // honor: { value: 0, label: 'Honor', multiplier: 1 },
      // justice: { value: 0, label: 'Justice', multiplier: 1 },
      // mercy: { value: 0, label: 'Mercy', multiplier: 1 },
      // grace: { value: 0, label: 'Grace', multiplier: 1 },
      // piety: { value: 0, label: 'Piety', multiplier: 1 },
      // humility: { value: 0, label: 'Humility', multiplier: 1 },
      // patience: { value: 0, label: 'Patience', multiplier: 1 },
      // diligence: { value: 0, label: 'Diligence', multiplier: 1 },
      // kindness: { value: 0, label: 'Kindness', multiplier: 1 },
      // temperance: { value: 0, label: 'Temperance', multiplier: 1 },
    };
  }

  setCallback(callback) {
    this.onChange = callback || this.onChange;
  }

  list() {
    return this.traits;
  }

  delta(traits, context) {
    Object.keys(traits).forEach(traitName => {
      this.modifyTrait(traitName, traits[traitName]);
    });
  }

  modifyTrait(traitName, amount) {
    if (this.traits[traitName]) {
      const trait = this.traits[traitName];
      const oldValue = trait.value;
      const newValue = Math.max(0, trait.value + amount);
      trait.value = newValue;
      trait.enabled = trait.enabled || oldValue !== newValue;
      this.onChange(traitName, oldValue, newValue); // Notify listener of the change
    }
  }

  getTrait(traitName) {
    return this.traits[traitName];
  }

  getTraitValue(traitName) {
    const trait = this.getTrait(traitName);
    if (!trait) return 0;
    return trait.value;
  }

  // eslint-disable-line no-unused-vars
  isTraitVisible(trait, phase) {
    return this.getTrait(trait).enabled;
  }

  // Additional methods as needed
}

export default Traits;
